import $foreign from "./foreign.cjs";
var bottomChar = $foreign.bottomChar;
var bottomInt = $foreign.bottomInt;
var bottomNumber = $foreign.bottomNumber;
var topChar = $foreign.topChar;
var topInt = $foreign.topInt;
var topNumber = $foreign.topNumber;
export { bottomChar, bottomInt, bottomNumber, topChar, topInt, topNumber };
